import { createVNode as n, mergeProps as l } from "vue";
import m from "../node_modules/@pf-ui/pf-icon-svg/es/asn/AlertTwoTone.js";
import s from "../components/PfIcon.js";
const o = (r, e) => {
  const t = {
    ...r,
    ...e.attrs
  };
  return n(s, l(t, {
    icon: m
  }), null);
};
o.displayName = "AlertTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
